import { Component, Input } from '@angular/core';
import * as mm from 'moment-timezone';

@Component({
  selector: 'app-module-type2-row-checkbox',
  template: `
    <!-- <label *ngIf="showInput" style="color:#2688DA"> &#10004; </label>
    <mat-checkbox
      [disabled]="disable"
      (change)="checkCheckBoxvalue($event)"
      [(ngModel)]="value"
    ></mat-checkbox> -->
    <div class="checkbox-container">
      <label *ngIf="showInput" class="checkmark-label">&#10004;</label>
      <mat-checkbox
        [disabled]="disable"
        (change)="checkCheckBoxvalue($event)"
        [(ngModel)]="value"
      ></mat-checkbox>
    </div>
  `,
  styles: [
    `
    .checkbox-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
      .checkmark-label {
        color: #2688da;
        margin-right: 5px;
      }
      ::ng-deep .mat-checkbox .mat-checkbox-frame {
        border: 1px solid #c5c5c5 !important;
      }
      ::ng-deep .mat-checkbox-disabled .mat-checkbox-background {
        background-color: #d3d3d3;
      }
      .mat-checkbox-disabled {
        cursor: not-allowed;
      }
    `,
  ],
})
export class ModuleType2RowCheckboxComponent {
@Input() cell: any;

  showInput: boolean;
  value: boolean = false;
  isEmpty = true;
  showCheckBox = true;
  editable: boolean;
  disable: boolean = false;
  public params: any;

agInit(params: any): void {
  this.params = params;

  if (params.column === 'moduleToDock') {
    this.showCheckBox = true;
    this.value = !!params.data.is_independent_mod;

    if (params.data.logic === '1') {
      this.disable = !params.data.is_independent_mod;
    } else if (params.data.logic === '2') {
      this.disable = params.data.is_independent_mod;
    } else {
      this.disable = false;
    }
  }

  if (params.column === 'conModule') {
    this.showCheckBox = true;
    this.value = !!params.data.is_controlling_mod;

    if (params.data.logic === '1') {
      this.disable = !params.data.is_independent_mod;
    } else if (params.data.logic === '2') {
      this.disable = params.data.is_independent_mod;
    } else {
      this.disable = false;
    }
  }

  if (this.params.data.checkedEditMode) {
    this.showCheckBox = true;
    this.showInput = false;
  } else {
    this.showCheckBox = false;
  }

  if (
    this.params.data.checkedEditMode &&
    new Date(this.params.data.date) <=
      new Date(String(mm().tz('US/Michigan').format('MM/DD/YYYY')).substring(0, 10))
  ) {
    this.disable = true;
  }
}

checkCheckBoxvalue(event) {
  const checked = !!event.checked;

  if (this.params.column === 'conModule') {
    this.params.data.is_controlling_mod = checked;
    if (checked) {
      this.params.data.is_independent_mod = false;
    }
  } else if (this.params.column === 'moduleToDock') {
    this.params.data.is_independent_mod = checked;
    if (checked) {
      this.params.data.is_controlling_mod = false;
    }
  }

  this.params.context.componentParent.editModuleTypeCheck(this.params);
}

  constructor() {}


}
